/**
 * Public URL of the client (what Google should index).
 * Defaults to bloomwik.com for Hostinger production.
 * Override with REACT_APP_SITE_URL at build time.
 */
export const DEFAULT_PUBLIC_SITE_URL = 'https://bloomwik.com';

/**
 * Returns the canonical site origin (no trailing slash).
 * Prefer env at build time; otherwise use the runtime origin (SPA) so Netlify works without env.
 */
export function getPublicSiteUrl() {
  const fromEnv = process.env.REACT_APP_SITE_URL;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return DEFAULT_PUBLIC_SITE_URL;
}
